import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

type SignPanelProps = {
  children: ReactNode;
  /** Padding scale. sm = nav/inline, md = card title, lg = hero wordmark. */
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

const sizePadding = {
  sm: 'px-3 py-1',
  md: 'px-6 py-3',
  lg: 'px-8 py-4 md:px-10 md:py-5',
};

/**
 * Lit "Welcome to Las Vegas" sign panel — cream face, gold frame, drop shadow.
 * Wrap marquee text in this to make it read against the dark casino-floor body.
 */
export function SignPanel({ children, size = 'md', className }: SignPanelProps) {
  return (
    <div className={cn('sign-panel', sizePadding[size], className)}>
      {children}
    </div>
  );
}
